"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5679],{

/***/ 65715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ ClassTable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/utils/isObject.js
function isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}

;// CONCATENATED MODULE: ./src/utils/castArray.js
function castArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Heading.js + 1 modules
var Heading = __webpack_require__(5679);
;// CONCATENATED MODULE: ./src/components/ClassTable.js







function stringifyProperties(properties) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _filter = ref.filter, filter = _filter === void 0 ? function() {
        return true;
    } : _filter, _transformValue = ref.transformValue, transformValue = _transformValue === void 0 ? function(x) {
        return x;
    } : _transformValue, _indent = ref.indent, indent = _indent === void 0 ? 0 : _indent;
    var lines = [];
    Object.keys(properties).forEach(function(property) {
        if (isObject(properties[property])) {
            lines.push("".concat(property, " {"));
            lines.push(stringifyProperties(properties[property], {
                filter: filter,
                transformValue: transformValue,
                indent: indent + 1
            }));
            lines.push("}");
        } else {
            castArray(properties[property]).forEach(function(value, i) {
                if (!filter(property, value, properties)) return;
                lines.push("".concat("  ".repeat(indent)).concat(property, ": ").concat(transformValue(value), ";"));
            });
        }
    });
    return lines.join("\n");
}
var ClassTable = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _utilities = param.utilities, utilities = _utilities === void 0 ? {} : _utilities, _filterRules = param.filterRules, filterRules = _filterRules === void 0 ? function() {
        return true;
    } : _filterRules, filterProperties = param.filterProperties, preview = param.preview, rowStyle = param.rowStyle, _sort = param.sort, sort = _sort === void 0 ? function(x) {
        return x;
    } : _sort, _transformSelector = param.transformSelector, transformSelector = _transformSelector === void 0 ? function(x) {
        return x.replace(/^\./g, "").replace(/\\/g, "");
    } : _transformSelector, _transformProperties = param.transformProperties, transformProperties = _transformProperties === void 0 ? function(param) {
        var properties = param.properties;
        return properties;
    } : _transformProperties, transformValue = param.transformValue, custom = param.custom, scroll = param.scroll;
    utilities = Object.fromEntries(Object.entries(utilities).filter(filterRules));
    var classes = Object.keys(utilities);
    var isScrollable = scroll || classes.length > 12;
    var isCollapsable = classes.length > 10;
    var ref = (0,react.useState)(isCollapsable), isCollapsed = ref[0], setIsCollapsed = ref[1];
    var ref1 = (0,react.useRef)();
    var isInitial = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        if (isInitial.current) {
            isInitial.current = false;
            return;
        }
        if (isCollapsed) {
            ref1.current.scrollIntoView(true);
        }
    }, [
        isCollapsed
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref1,
        className: "mt-10 relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                level: 2,
                id: "class-reference",
                className: "relative scroll-mt-[var(--scroll-mt)]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: "Quick reference"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("overflow-hidden lg:overflow-auto scrollbar-w-1.5 scrollbar-track-gray-100 scrollbar-thumb-rounded scrollbar-thumb-gray-300 scrollbar-track-rounded", isCollapsed && "max-h-96", !isScrollable && isCollapsed && "lg:max-h-[none]", isScrollable && "supports-scrollbars:pr-2 lg:max-h-96"),
                children: [
                    custom || /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "w-full text-left border-collapse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "sticky z-10 top-0 text-sm leading-6 font-semibold text-gray-700 bg-white p-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "py-2 pr-2 border-b border-gray-200",
                                                children: "Class"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: (0,clsx_m/* default */.Z)("sticky z-10 top-0 text-sm leading-6 font-semibold text-gray-700 bg-white p-0", {
                                                "hidden sm:table-cell": preview
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)("py-2 pl-2 border-b border-gray-200", {
                                                    "pr-2": preview
                                                }),
                                                children: "Properties"
                                            })
                                        }),
                                        preview && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "sticky z-10 top-0 text-sm leading-6 font-semibold text-gray-700 bg-white p-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "py-2 pl-2 border-b border-gray-200",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Preview"
                                                    }),
                                                    "\xa0"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                className: "align-baseline",
                                children: sort(classes).map(function(utility, i) {
                                    var selector = utility;
                                    var properties = (0,_object_spread/* default */.Z)({}, utilities[selector]);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        style: rowStyle ? rowStyle({
                                            css: properties
                                        }) : undefined,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                translate: "no",
                                                className: (0,clsx_m/* default */.Z)("py-2 pr-2 font-mono font-medium text-xs leading-6 text-color10 whitespace-nowrap", {
                                                    "border-t border-gray-100": i !== 0
                                                }),
                                                children: transformSelector(selector)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                translate: "no",
                                                className: (0,clsx_m/* default */.Z)("py-2 pl-2 font-mono text-xs leading-6 text-indigo-600 whitespace-pre", {
                                                    "border-t border-gray-100": i !== 0,
                                                    "hidden sm:table-cell sm:pr-2": preview
                                                }),
                                                children: stringifyProperties(transformProperties({
                                                    selector: selector,
                                                    properties: properties
                                                }), {
                                                    filter: filterProperties,
                                                    transformValue: transformValue
                                                })
                                            }),
                                            preview && preview(properties, {
                                                utility: utility,
                                                className: i === 0 ? "" : "border-t border-gray-100"
                                            })
                                        ]
                                    }, utility);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sticky bottom-0 h-px -mt-px bg-gray-200"
                    })
                ]
            }),
            isCollapsable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("inset-x-0 flex justify-center lg:hidden", isCollapsed ? "-mt-9 relative" : "mt-4 sticky bottom-[calc(1rem+env(safe-area-inset-bottom,0))]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("absolute inset-x-0 bg-gradient-to-t from-white", isCollapsed ? "-top-8 bottom-0" : "-top-4 bottom-[calc(-1*(1rem+env(safe-area-inset-bottom,0)))]")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            return setIsCollapsed(!isCollapsed);
                        },
                        className: "relative text-sm font-semibold text-gray-900 bg-white py-2 px-4 rounded-full ring-1 ring-gray-900/10 shadow-sm",
                        children: isCollapsed ? "Show all classes" : "Show fewer classes"
                    })
                ]
            })
        ]
    });
});


/***/ }),

/***/ 5679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Heading; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/layouts/ContentsLayout.js
var ContentsLayout = __webpack_require__(33481);
// EXTERNAL MODULE: ./node_modules/@reach/rect/dist/rect.esm.js + 2 modules
var rect_esm = __webpack_require__(47916);
;// CONCATENATED MODULE: ./src/hooks/useTop.js


function useTop(ref) {
    var _$ref = (0,react.useState)(), top = _$ref[0], setTop = _$ref[1];
    var rect = (0,rect_esm/* useRect */.EL)(ref);
    var rectTop = rect ? rect.top : undefined;
    (0,react.useEffect)(function() {
        if (typeof rectTop === "undefined") return;
        var newTop = rectTop + window.pageYOffset;
        if (newTop !== top) {
            setTop(newTop);
        }
    }, [
        rectTop,
        top
    ]);
    return top;
}

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/layouts/CustomContentsLayout.js
var CustomContentsLayout = __webpack_require__(87274);
;// CONCATENATED MODULE: ./src/components/Heading.js









function Heading(_param) {
    var level = _param.level, id = _param.id, children = _param.children, number = _param.number, badge = _param.badge, _className = _param.className, className = _className === void 0 ? "" : _className, _hidden = _param.hidden, hidden = _hidden === void 0 ? false : _hidden, _ignore = _param.ignore, ignore = _ignore === void 0 ? false : _ignore, _style = _param.style, style = _style === void 0 ? {} : _style, nextElement = _param.nextElement, props = (0,_object_without_properties/* default */.Z)(_param, [
        "level",
        "id",
        "children",
        "number",
        "badge",
        "className",
        "hidden",
        "ignore",
        "style",
        "nextElement"
    ]);
    var Component = "h".concat(level);
    var context = (0,react.useContext)(ContentsLayout/* ContentsContext */.wc);
    var context2 = (0,react.useContext)(CustomContentsLayout/* CustomContentsContext */.R2);
    var ref = (0,react.useRef)();
    var top = useTop(ref);
    (0,react.useEffect)(function() {
        if (!context) return;
        if (typeof top !== "undefined") {
            context.registerHeading(id, top);
        }
        return function() {
            context.unregisterHeading(id);
        };
    }, [
        top,
        id,
        context === null || context === void 0 ? void 0 : context.registerHeading,
        context === null || context === void 0 ? void 0 : context.unregisterHeading
    ]);
    (0,react.useEffect)(function() {
        if (!context2) return;
        if (typeof top !== "undefined") {
            context2.registerHeading(id, top);
        }
        return function() {
            context2.unregisterHeading(id);
        };
    }, [
        top,
        id,
        context2 === null || context2 === void 0 ? void 0 : context2.registerHeading,
        context2 === null || context2 === void 0 ? void 0 : context2.unregisterHeading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)("group flex whitespace-pre-wrap", className, {
            "-ml-4 pl-4": !hidden,
            "mb-2 text-sm leading-6 text-color10 font-semibold tracking-normal": level === 2 && (nextElement === null || nextElement === void 0 ? void 0 : nextElement.type) === "heading" && (nextElement === null || nextElement === void 0 ? void 0 : nextElement.depth) === 3
        }),
        id: id,
        ref: ref,
        style: (0,_object_spread/* default */.Z)({}, hidden ? {
            marginBottom: 0
        } : {}, style),
        "data-docsearch-ignore": ignore ? "" : undefined
    }, props), {
        children: [
            !hidden && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: "#".concat(id),
                className: "absolute -ml-10 flex items-center opacity-0 border-0 group-hover:opacity-100",
                "aria-label": "Anchor",
                children: [
                    "​",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-6 h-6 text-gray-400 ring-1 ring-gray-900/5 rounded-md shadow-sm flex items-center justify-center hover:ring-gray-900/10 hover:shadow hover:text-gray-700",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "12",
                            height: "12",
                            fill: "none",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M3.75 1v10M8.25 1v10M1 3.75h10M1 8.25h10",
                                stroke: "currentColor",
                                strokeWidth: "1.5",
                                strokeLinecap: "round"
                            })
                        })
                    })
                ]
            }),
            number && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "bg-cyan-100 w-8 h-8 inline-flex items-center justify-center rounded-full text-cyan-700 text-xl mr-3 flex-none",
                children: number
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: hidden ? "sr-only" : undefined,
                children: children
            }),
            badge && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "ml-3 inline-flex items-center px-3 py-1 rounded-full text-sm font-medium leading-4 bg-green-150 text-green-900",
                children: badge
            })
        ]
    }));
}


/***/ }),

/***/ 58:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ PageHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function PageHeader(param) {
    var title = param.title, description = param.description, _badge = param.badge, badge = _badge === void 0 ? {} : _badge, section = param.section;
    if (!title && !description) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        id: "header",
        className: "relative z-20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    section && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-2 text-sm leading-6 font-semibold text-color10",
                        children: section
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "inline-block text-3xl font-extrabold text-gray-900 tracking-tight",
                        children: title
                    }),
                    badge.key && badge.value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", {
                        className: "ml-3 mt-1.5 align-top inline-flex items-center px-3 py-1 rounded-full text-sm font-medium leading-4 bg-cyan-100 text-cyan-900 tracking-tight",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                className: "sr-only",
                                children: badge.key
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                children: badge.value
                            })
                        ]
                    })
                ]
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mt-2 text-lg text-gray-700",
                children: description
            })
        ]
    });
}


/***/ }),

/***/ 76587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ usePrevNext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21744);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



function usePrevNext() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var nav = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_1__/* .SidebarContext */ .l).nav;
    var pages = Object.keys(nav).flatMap(function(category) {
        return nav[category];
    });
    var pageIndex = pages.findIndex(function(page) {
        return page.href === router.pathname;
    });
    return {
        prev: pageIndex > -1 ? pages[pageIndex - 1] : undefined,
        next: pageIndex > -1 ? pages[pageIndex + 1] : undefined
    };
}


/***/ }),

/***/ 33481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X_": function() { return /* binding */ ContentsLayout; },
/* harmony export */   "wc": function() { return /* binding */ ContentsContext; }
/* harmony export */ });
/* unused harmony export ContentsLayoutOuter */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ClassTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65715);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_usePrevNext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76587);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21744);
/* harmony import */ var _components_PageHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86010);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66278);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5679);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3905);
/* harmony import */ var _partials_Cta2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46745);
/* harmony import */ var _partials_DocsNewsletter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45898);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_13__);



















var ContentsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
function TableOfContents(param) {
    var tableOfContents = param.tableOfContents, currentSection = param.currentSection;
    var closeNav = function closeNav() {
        if (isMainNav) {
            sidebarContext.setNavIsOpen(false);
        }
    };
    var sidebarContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_6__/* .SidebarContext */ .l);
    var isMainNav = Boolean(sidebarContext);
    function isActive(section) {
        if (section.slug === currentSection) {
            return true;
        }
        if (!section.children) {
            return false;
        }
        return section.children.findIndex(isActive) > -1;
    }
    var pageHasSubsections = tableOfContents.some(function(section) {
        return section.children.length > 0;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: "text-gray-900 font-semibold mb-4 text-sm leading-6",
                children: "On this page"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "text-gray-700 text-sm leading-6",
                children: tableOfContents.map(function(section) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "#".concat(section.slug),
                                    onClick: closeNav,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("block py-1", pageHasSubsections ? "font-medium" : "", isActive(section) ? "font-medium text-color10" : "hover:text-gray-900"),
                                    children: section.title
                                })
                            }),
                            section.children.map(function(subsection) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "ml-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: "#".concat(subsection.slug),
                                        onClick: closeNav,
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("group flex items-start py-1", isActive(subsection) ? "text-color10" : "hover:text-gray-900"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                width: "3",
                                                height: "24",
                                                viewBox: "0 -9 3 24",
                                                className: "mr-2 text-gray-400 overflow-visible group-hover:text-gray-600",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M0 0L3 3L0 6",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                })
                                            }),
                                            subsection.title
                                        ]
                                    })
                                }, subsection.slug);
                            })
                        ]
                    }, section.slug);
                })
            })
        ]
    });
}
function useTableOfContents(tableOfContents) {
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((ref = tableOfContents[0]) === null || ref === void 0 ? void 0 : ref.slug), currentSection = ref1[0], setCurrentSection = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), headings = ref2[0], setHeadings = ref2[1];
    var registerHeading = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(id, top) {
        setHeadings(function(headings) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(headings.filter(function(h) {
                return id !== h.id;
            })).concat([
                {
                    id: id,
                    top: top
                }
            ]);
        });
    }, []);
    var unregisterHeading = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(id) {
        setHeadings(function(headings) {
            return headings.filter(function(h) {
                return id !== h.id;
            });
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var onScroll = function onScroll() {
            var y = window.pageYOffset;
            var windowHeight = window.innerHeight;
            var sortedHeadings = headings.concat([]).sort(function(a, b) {
                return a.top - b.top;
            });
            if (y <= 0) {
                setCurrentSection(sortedHeadings[0].id);
                return;
            }
            if (y + windowHeight >= document.body.scrollHeight) {
                setCurrentSection(sortedHeadings[sortedHeadings.length - 1].id);
                return;
            }
            var middle = y + windowHeight / 2;
            var current = sortedHeadings[0].id;
            for(var i = 0; i < sortedHeadings.length; i++){
                if (middle >= sortedHeadings[i].top) {
                    current = sortedHeadings[i].id;
                }
            }
            setCurrentSection(current);
        };
        if (tableOfContents.length === 0 || headings.length === 0) return;
        window.addEventListener("scroll", onScroll, {
            capture: true,
            passive: true
        });
        onScroll();
        return function() {
            return window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        headings,
        tableOfContents
    ]);
    return {
        currentSection: currentSection,
        registerHeading: registerHeading,
        unregisterHeading: unregisterHeading
    };
}
function ContentsLayoutOuter(_param) {
    var children = _param.children, layoutProps = _param.layoutProps, props = _object_without_properties(_param, [
        "children",
        "layoutProps"
    ]);
    var ref = useTableOfContents(layoutProps.tableOfContents), currentSection = ref.currentSection, registerHeading = ref.registerHeading, unregisterHeading = ref.unregisterHeading;
    return /*#__PURE__*/ _jsx(SidebarLayout, _object_spread_props(_object_spread({
        sidebar: /*#__PURE__*/ _jsx("div", {
            className: "mb-8",
            children: /*#__PURE__*/ _jsx(TableOfContents, {
                tableOfContents: layoutProps.tableOfContents,
                currentSection: currentSection
            })
        })
    }, props), {
        children: /*#__PURE__*/ _jsx(ContentsContext.Provider, {
            value: {
                registerHeading: registerHeading,
                unregisterHeading: unregisterHeading
            },
            children: children
        })
    }));
}
function ContentsLayout(param) {
    var children = param.children, meta = param.meta, classes = param.classes, tableOfContents = param.tableOfContents, section = param.section;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var toc = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(classes ? [
        {
            title: "Quick reference",
            slug: "class-reference",
            children: []
        }
    ] : []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(tableOfContents));
    var ref = useTableOfContents(toc), currentSection = ref.currentSection, registerHeading = ref.registerHeading, unregisterHeading = ref.unregisterHeading;
    var ref1 = (0,_hooks_usePrevNext__WEBPACK_IMPORTED_MODULE_4__/* .usePrevNext */ .G)(), prev = ref1.prev, next = ref1.next;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: " relative w-full flex ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_13___default()), {
                children: (meta === null || meta === void 0 ? void 0 : meta.meta_description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: meta === null || meta === void 0 ? void 0 : meta.meta_description
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: " flex-grow mx-auto md:pl-7",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageHeader__WEBPACK_IMPORTED_MODULE_7__/* .PageHeader */ .m, {
                        title: meta.title,
                        description: meta.description,
                        badge: {
                            key: "Tradly",
                            value: meta.featureVersion
                        },
                        section: section
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentsContext.Provider, {
                        value: {
                            registerHeading: registerHeading,
                            unregisterHeading: unregisterHeading
                        },
                        children: [
                            classes ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ClassTable__WEBPACK_IMPORTED_MODULE_2__/* .ClassTable */ .P, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, classes)),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        id: "content",
                                        className: "relative z-20 prose mt-12",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mdx_js_react__WEBPACK_IMPORTED_MODULE_10__/* .MDXProvider */ .Zo, {
                                            components: {
                                                Heading: _components_Heading__WEBPACK_IMPORTED_MODULE_9__/* .Heading */ .X
                                            },
                                            children: children
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "content",
                                className: "relative z-20 prose mt-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mdx_js_react__WEBPACK_IMPORTED_MODULE_10__/* .MDXProvider */ .Zo, {
                                    components: {
                                        Heading: _components_Heading__WEBPACK_IMPORTED_MODULE_9__/* .Heading */ .X
                                    },
                                    children: children
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_DocsNewsletter__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " flex-none bottom-0 w-[19rem] py-10 pl-12 hidden xl:block",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: " sticky h-auto max-h-screen overflow-y-auto top-[5.8125rem] z-10 ",
                    children: toc.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TableOfContents, {
                        tableOfContents: toc,
                        currentSection: currentSection
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 87274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NH": function() { return /* binding */ CustomContentsLayout; },
/* harmony export */   "R2": function() { return /* binding */ CustomContentsContext; }
/* harmony export */ });
/* unused harmony export ContentsLayoutOuter */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ClassTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65715);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_usePrevNext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76587);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21744);
/* harmony import */ var _components_PageHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86010);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66278);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5679);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3905);
/* harmony import */ var _partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48777);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_12__);


















var CustomContentsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
function TableOfContents(param) {
    var tableOfContents = param.tableOfContents, currentSection = param.currentSection;
    var closeNav = function closeNav() {
        if (isMainNav) {
            sidebarContext.setNavIsOpen(false);
        }
    };
    var sidebarContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_6__/* .SidebarContext */ .l);
    var isMainNav = Boolean(sidebarContext);
    function isActive(section) {
        if (section.slug === currentSection) {
            return true;
        }
        if (!section.children) {
            return false;
        }
        return section.children.findIndex(isActive) > -1;
    }
    var pageHasSubsections = tableOfContents.some(function(section) {
        return section.children.length > 0;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: "text-gray-900 font-semibold mb-4 text-sm leading-6",
                children: "On this page"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "text-gray-700 text-sm leading-6",
                children: tableOfContents.map(function(section) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "#".concat(section.slug),
                                    onClick: closeNav,
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("block py-1", pageHasSubsections ? "font-medium" : "", isActive(section) ? "font-medium text-color10" : "hover:text-gray-900"),
                                    children: section.title
                                })
                            }),
                            section.children.map(function(subsection) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "ml-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: "#".concat(subsection.slug),
                                        onClick: closeNav,
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("group flex items-start py-1", isActive(subsection) ? "text-color10" : "hover:text-gray-900"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                width: "3",
                                                height: "24",
                                                viewBox: "0 -9 3 24",
                                                className: "mr-2 text-gray-400 overflow-visible group-hover:text-gray-600",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M0 0L3 3L0 6",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                })
                                            }),
                                            subsection.title
                                        ]
                                    })
                                }, subsection.slug);
                            })
                        ]
                    }, section.slug);
                })
            })
        ]
    });
}
function useTableOfContents(tableOfContents) {
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((ref = tableOfContents[0]) === null || ref === void 0 ? void 0 : ref.slug), currentSection = ref1[0], setCurrentSection = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), headings = ref2[0], setHeadings = ref2[1];
    var registerHeading = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(id, top) {
        setHeadings(function(headings) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(headings.filter(function(h) {
                return id !== h.id;
            })).concat([
                {
                    id: id,
                    top: top
                }
            ]);
        });
    }, []);
    var unregisterHeading = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(id) {
        setHeadings(function(headings) {
            return headings.filter(function(h) {
                return id !== h.id;
            });
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var onScroll = function onScroll() {
            var y = window.pageYOffset;
            var windowHeight = window.innerHeight;
            var sortedHeadings = headings.concat([]).sort(function(a, b) {
                return a.top - b.top;
            });
            if (y <= 0) {
                setCurrentSection(sortedHeadings[0].id);
                return;
            }
            if (y + windowHeight >= document.body.scrollHeight) {
                setCurrentSection(sortedHeadings[sortedHeadings.length - 1].id);
                return;
            }
            var middle = y + windowHeight / 2;
            var current = sortedHeadings[0].id;
            for(var i = 0; i < sortedHeadings.length; i++){
                if (middle >= sortedHeadings[i].top) {
                    current = sortedHeadings[i].id;
                }
            }
            setCurrentSection(current);
        };
        if (tableOfContents.length === 0 || headings.length === 0) return;
        window.addEventListener("scroll", onScroll, {
            capture: true,
            passive: true
        });
        onScroll();
        return function() {
            return window.removeEventListener("scroll", onScroll, true);
        };
    }, [
        headings,
        tableOfContents
    ]);
    return {
        currentSection: currentSection,
        registerHeading: registerHeading,
        unregisterHeading: unregisterHeading
    };
}
function ContentsLayoutOuter(_param) {
    var children = _param.children, layoutProps = _param.layoutProps, props = _object_without_properties(_param, [
        "children",
        "layoutProps"
    ]);
    var ref = useTableOfContents(layoutProps.tableOfContents), currentSection = ref.currentSection, registerHeading = ref.registerHeading, unregisterHeading = ref.unregisterHeading;
    return /*#__PURE__*/ _jsx(SidebarLayout, _object_spread_props(_object_spread({
        sidebar: /*#__PURE__*/ _jsx("div", {
            className: "mb-8",
            children: /*#__PURE__*/ _jsx(TableOfContents, {
                tableOfContents: layoutProps.tableOfContents,
                currentSection: currentSection
            })
        })
    }, props), {
        children: /*#__PURE__*/ _jsx(CustomContentsContext.Provider, {
            value: {
                registerHeading: registerHeading,
                unregisterHeading: unregisterHeading
            },
            children: children
        })
    }));
}
function CustomContentsLayout(param) {
    var children = param.children, meta = param.meta, classes = param.classes, tableOfContents = param.tableOfContents, section = param.section;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var toc = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes ? [
        {
            title: "Quick reference",
            slug: "class-reference",
            children: []
        }
    ] : []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(tableOfContents));
    var ref = useTableOfContents(toc), currentSection = ref.currentSection, registerHeading = ref.registerHeading, unregisterHeading = ref.unregisterHeading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_12___default()), {
                children: (meta === null || meta === void 0 ? void 0 : meta.meta_description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: meta === null || meta === void 0 ? void 0 : meta.meta_description
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: [
                    " relative w-full flex  pb-10   mx-auto  ",
                    toc.length > 0 ? " max-w-6xl xl:max-w-8xl" : "max-w-6xl", 
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: [
                            " flex-grow mx-auto px-5 ",
                            toc.length > 0 ? "xl:pl-40" : "pl-0"
                        ].join(" "),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageHeader__WEBPACK_IMPORTED_MODULE_7__/* .PageHeader */ .m, {
                                title: meta.title,
                                description: meta.description,
                                badge: {
                                    key: "Tradly",
                                    value: meta.featureVersion
                                },
                                section: section
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomContentsContext.Provider, {
                                value: {
                                    registerHeading: registerHeading,
                                    unregisterHeading: unregisterHeading
                                },
                                children: classes ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ClassTable__WEBPACK_IMPORTED_MODULE_2__/* .ClassTable */ .P, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, classes)),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            id: "content",
                                            className: "relative z-20 prose mt-12",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mdx_js_react__WEBPACK_IMPORTED_MODULE_10__/* .MDXProvider */ .Zo, {
                                                components: {
                                                    Heading: _components_Heading__WEBPACK_IMPORTED_MODULE_9__/* .Heading */ .X
                                                },
                                                children: children
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    id: "content",
                                    className: "relative z-20 prose mt-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mdx_js_react__WEBPACK_IMPORTED_MODULE_10__/* .MDXProvider */ .Zo, {
                                        components: {
                                            Heading: _components_Heading__WEBPACK_IMPORTED_MODULE_9__/* .Heading */ .X
                                        },
                                        children: children
                                    })
                                })
                            })
                        ]
                    }),
                    toc.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " flex-none bottom-0 w-[19.5rem] py-10 px-8 hidden xl:block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: " sticky h-auto max-h-screen overflow-y-auto top-[5.8125rem] z-10 ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TableOfContents, {
                                tableOfContents: toc,
                                currentSection: currentSection
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
            })
        ]
    });
}


/***/ }),

/***/ 46745:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




function Cta2() {
    var router = useRouter();
    return /*#__PURE__*/ _jsx("section", {
        children: /*#__PURE__*/ _jsx("div", {
            className: " w-full mx-auto ",
            children: /*#__PURE__*/ _jsx("div", {
                className: " ",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "bg-gray-100 rounded py-10 px-8 md:py-16 md:px-8 shadow-2xl",
                    "data-aos": "zoom-y-out",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col justify-between items-center",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-6 lg:mr-16 text-center ",
                                children: [
                                    /*#__PURE__*/ _jsxs("h3", {
                                        className: "h3 text-black mb-2",
                                        children: [
                                            " ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400",
                                                children: "DREAMS becomes Reality"
                                            }),
                                            " ",
                                            "when you START"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-black text-lg opacity-75",
                                        children: "Our pricing is simple and starts with ZERO, you pay only when you make money"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    className: "btn custom_gradient_btn text-white px-20",
                                    href: "https://community.tradly.app/",
                                    target: "_blank",
                                    children: "Join Our Community"
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Cta2)));


/***/ }),

/***/ 45898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function DocsNewsletter() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-6xl mx-auto px-4 sm:px-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "py-12 md:py-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative bg-gray-100 rounded py-10 px-8 md:py-16 md:px-12 shadow-2xl overflow-hidden",
                    "data-aos": "zoom-y-out",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute right-0 bottom-0 pointer-events-none hidden lg:block",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                width: "428",
                                height: "328",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("radialGradient", {
                                            cx: "35.542%",
                                            cy: "34.553%",
                                            fx: "35.542%",
                                            fy: "34.553%",
                                            r: "96.031%",
                                            id: "ni-a",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0.25"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                                    offset: "1",
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                        fill: "none",
                                        fillRule: "evenodd",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                                fill: "#34CDB1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".04",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "16",
                                                        ry: "15.576"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".24",
                                                        cx: "100",
                                                        cy: "68.402",
                                                        rx: "24",
                                                        ry: "23.364"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "29",
                                                        ry: "28.231"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "342",
                                                        cy: "31.303",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".48",
                                                        cx: "62",
                                                        cy: "126.811",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "78",
                                                        cy: "7.072",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "6",
                                                        ry: "5.841"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                fill: "url(#ni-a)",
                                                cx: "276",
                                                cy: "237",
                                                r: "200"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative flex flex-col lg:flex-row justify-between items-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center lg:text-left lg:max-w-xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "h3 text-black mb-6",
                                        children: "Got questions? "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                        className: "w-full lg:w-auto",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex flex-col sm:flex-row justify-start max-w-xs mx-auto sm:max-w-md lg:mx-0",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "btn text-white bg-blue-600 hover:bg-blue-700 shadow",
                                                    href: "https://community.tradly.app?utm_source=tradly.app&utm_medium=docs",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "Join the community"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-400 mt-3",
                                                children: "No spam. You can unsubscribe at any time."
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DocsNewsletter);


/***/ })

}]);